import { graphql } from 'react-relay';

export * from './__generated__/ZnglyInfo_Settings_Fragment.graphql';
export const SettingsFragment = graphql`
  fragment ZnglyInfo_Settings_Fragment on RootQuery {
    znglyInfo(id: "site-info", idType: SLUG) {
      id
      znglyInfo {
        ...integrations_Settings_Fragment
        ...analytics_Settings_Fragment
        ...privacyPolicy_Settings_Fragment
        ...siteSettings_Settings_Fragment
        ...globalStyles_Settings_Fragment
        ...qrCodeTab_Settings_Fragment
        ...backend_Settings_Fragment
        ...personalisedVideo_Settings_Fragment
        ...header_Settings_Fragment
        ...body_Settings_Fragment
        ...footer_Settings_Fragment
        ...homePage_Settings_Fragment
        ...chatbot_Settings_Fragment
      }
    }
  }
`;

export * from './__generated__/ZnglyInfo_PrivacyPolicy_Query.graphql';
export const PrivacyPolicyQuery = graphql`
  query ZnglyInfo_PrivacyPolicy_Query {
    znglyInfo(id: "site-info", idType: SLUG) {
      znglyInfo {
        privacyPolicy
        privacyPolicyTitle
      }
    }
  }
`;

export * from './__generated__/ZnglyInfo_SettingsStudioImages_Query.graphql';
export const SettingsStudioImagesQuery = graphql`
  query ZnglyInfo_SettingsStudioImages_Query {
    znglyInfo(id: "site-info", idType: SLUG) {
      znglyInfo {
        pvImages {
          image {
            ...Media_Url_Fragment @relay(mask: false)
          }
        }
      }
    }
  }
`;
